module.exports = __webpack_public_path__ + "img/wx1.87912f24.png";